import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";

class VideoItemModal extends Modal {
    constructor(item, settings = {okayText: null, title: null}) {
        super({class: "admin-modal--video admin-modal--navigation"});
        this.item = item;
        this.data = $.extend(true, {}, item.data);

        this.setContent(
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                    eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active", type: "button"}, ["Edit Video"])
                ]),
                eotwJSXFactory('h1', null, [settings.title ? settings.title : "Video"]),
                eotwJSXFactory('p', null, ["Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas bibendum ex at euismod accumsan. Nulla facilisi. Sed sodales rutrum lacus, et ullamcorper felis varius eu. "]),

                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"}, [
                    eotwJSXFactory('div', {class: "admin-form__row admin-modal--video__preview-wrap admin-gallery__video admin-gallery__video--large"}, [
                        eotwJSXFactory('img', {class: "admin-modal--video__preview js-canvas", src: item.data.customData.thumbnail})
                    ])
                ]),

                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--half"}, [
                    eotwJSXFactory('div', {class: "admin-form__row"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "video-title"}, ["Video URL"]),
                        eotwJSXFactory('div', {class: "admin-form__input admin-form__input--gallery admin-form__input--disabled"}, [
                            eotwJSXFactory('a', {href: this.data.customData.url, target: "_blank"}, [this.data.customData.url])
                        ]),
                        eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                    ]),

                    eotwJSXFactory('div', {class: "admin-form__row"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "video-title"}, ["Title"]),
                        eotwJSXFactory('input', {type: "text", class: "admin-form__input admin-form__input--gallery", id: "video-title", name: "title", value: this.data.title}),
                        eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                    ])
                ]),

                this.item.gallery.data.profile.showDescriptions ?
                    eotwJSXFactory('div', {class: "admin-form__row"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "video-description"}, ["Description"]),
                        eotwJSXFactory('textarea', {type: "text", class: "admin-form__input admin-form__input--textarea admin-form__input--gallery", id: "video-description", name: "description"}, [this.data.description]),
                        eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                    ]) : [],


                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, [settings.okayText ? settings.okayText : "Ok"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ])
        );

        this.bindEvents();
    }


    bindEvents() {
        this.on("click", ".js-cancel", () => this.emit("cancel") && this.destroy() && false);

        FormValidator.attach(this.$content).on("submit", ($form) => {

            $.extend(this.item.data, $form.serializeJSON());

            this.item.changed = true;

            this.emit("okay");
            this.destroy();
        });

    }


}


export default VideoItemModal;
